import { Flex, Form } from "antd"

import Button from "../../../../Components/Button"

const areFilled = (values, keys) => keys.every((k) => !!values?.[k]?.toString().trim())

export function PartnerModalActions({ form, onCancel, isEdit, submitting, hasLogo }) {
  const values = Form.useWatch([], form)

  const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0)
  const requiredKeys = [
    "partner_name",
    "partner_website",
    "offer_details",
    "description",
    "url",
    ...(values?.promocode_enabled ? ["promocode"] : [])
  ]
  const filled = areFilled(values, requiredKeys)

  return (
    <Flex justify={"flex-end"} gap={8}>
      <Button onClick={onCancel} disabled={submitting} data-testid="partner-modal-cancel-btn">
        {"Cancel"}
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        loading={submitting}
        disabled={submitting || !hasLogo || !filled || hasErrors}
        data-testid="partner-modal-submit-btn"
      >
        {isEdit ? "Save" : "Add partner"}
      </Button>
    </Flex>
  )
}
